import { put, call, takeLatest, select, take, all, race } from "redux-saga/effects";
import React from 'react';
var momentTz = require('moment-timezone');
import * as Api from "../api";
import { getNotificationData } from "../../Header/api";
import { status as notificationStatus } from "../../Header/Notification/constants";
import * as SpockApi from "../../SpockViewPage/api";
import { fetchRelationships, fetchActiveContracts } from "../../AdminPanel/api";
import { getOrgId } from "../../../utils/authManager";
import * as ActionConstants from "../actions/actionConstants";
import { SHOW_LOADER, HIDE_LOADER, SESSIONCONTEXT_DATA, SHOW_TOAST_WITH_PROPS } from '../../../common/actionConstants';
import { HIDE_DIALOGUE_BOX } from '../../../components/DialogueBox/actionConstants'
import * as WorkkardErrorConstant from '../../WorkkardDetail/errorConstant';
import { CLOSE_ACTIVITY_ERROR_VALIDATION_MESSAGE, CLOSE_WORKKARD_ERROR_VALIDATION_MESSAGE, StringConstants, RightPanelConstant, ErrorCode, APP_ERROR_CODES, noteFilterConstants } from '../constants';
import { DEFAULT_TIME_FORMAT } from '../../../common/constants';
import { CHANGE_ACTIVITY_ASSIGNEE_ERROR_VALIDATION_MESSAGE } from '../../../components/ChangeActivityAssignee/constants';
import { GET_REASSIGN_ACTIVITY_REQUEST, GET_REASSIGN_ACTIVITY_REQUEST_SUCCESS } from '../../../components/ChangeAssignee/actionConstants';
import { getActivityListingData, updateActivityListingData, getActivityDetail, } from '../Saga/leftPanelContainer';
import { updatePanelDataPermissionSet } from '../Saga/middlePanelContainer';
import { setObjectInStorage , getAxiosError, DigestNoteFilters} from "../../../common/util";
import { wsDisconnect } from "../../../common/actions/websocketActions";
import { PATHS } from "../../../router/paths";
import { dispatchCustomEvent } from '../utils';
import  *  as  PUBLIC_API_ACTIVITY_ACTION from "../../../publicApiActions/activityActions";
import * as PUBLIC_API_NOTE_ACTIONS from "../../../publicApiActions/noteActions";
import { buildInlineFieldPatch } from "../inlineFieldPatch";
import { delay } from "redux-saga";
import { WS_MESSAGE } from "../../../common/actions/websocketActions";
import { normalizeWorkkard } from "../../../common/normalizers/workkardFields"
import { fetchUser } from "../../AdminPanel/features/users/usersAPI";
import { hydrateUsers } from "@/common/sagas/userListSaga";
import * as MenuHelper from '../../../common/menuHelper';
import { normalizePermissions } from '../../../common/normalizers/userPermission';
import { fetchSessionContextOidcSuccess, fetchSessionContextOidcError } from "../../../common/reducers/sessionContextOidc";

export function* getWorkkardDetailMasterData({ payload }) {
  // A socket-driven refresh passes `silent`: the loader here is the app-wide one,
  // and flashing it over a page the user is reading is worse than the staleness it
  // is covering. Kept symmetric with the HIDE_LOADER below -- the loader is a
  // counter, so a one-sided skip would leave it permanently raised.
  const silent = !!payload.silent;
  try {
    if (!silent) yield put({ type: SHOW_LOADER });
    const reqPayload = { ...payload };
    delete reqPayload.callback;
    delete reqPayload.resetPinnedFields;
    const { workkard, status, isDiffrentUser} = yield call(Api.getWorkkardDetailMasterData, reqPayload);
    if (status == 200) {
      if (workkard) {
        let userSessionContext = yield select((state) => state.sessionContextOidc);
        if (!userSessionContext?.loaded) {
          yield take([fetchSessionContextOidcSuccess.type, fetchSessionContextOidcError.type]);
          userSessionContext = yield select((state) => state.sessionContextOidc);
        }
        const mappedWorkkard = normalizeWorkkard(workkard)
        mappedWorkkard.ActionMenu = MenuHelper.GetWorkkardActionsMenuList(normalizePermissions(userSessionContext.userView.permissions), userSessionContext.userView.orgId, mappedWorkkard.OrganizationId, mappedWorkkard.WorkkardStatus?.toUpperCase() !== "CLOSE", mappedWorkkard.IsClaimWorkkard)
        yield put({ type: ActionConstants.WORKKARD_DETAIL_MASTER_DATA_SUCCESS, payload: {...mappedWorkkard, ...(payload.resetPinnedFields ? { resetPinnedFields: true } : {})} });
        if (!payload.doNotUpdateSessionContext) {          
          yield put({ type: SESSIONCONTEXT_DATA, payload: { ...userSessionContext, isDiffrentUser } });
        }
        if (isDiffrentUser) {
          setObjectInStorage("isDiffrentUser", isDiffrentUser)
          window.location.reload()
        }
      }
      if (payload.callback) {
        payload.callback(workkard);
      }
      if (!payload.doNotUpdateNoteFilters) {
        yield* getsavednotefilters({ payload });
      }
      if (!payload.doNotUpdateActivityListing) {
        yield* getActivityListingData({ payload });
      }
      if (payload.updateActivityDetail && (payload.actId || payload.referrer)) {
        if (payload.referrer && payload.referrer == "views") {
          delete payload.referrer;
          const apiResponse = yield call(Api.getActivityListByClaim, payload);
          const { status, activities, Activities } = apiResponse || {};
          
          if (status == 200) {
            const activitiesArray = activities || Activities;
            if (activitiesArray && activitiesArray.length) {
              const firstActivityId = activitiesArray[0].ActivityId || activitiesArray[0].activityId;
              yield* getActivityDetail({ payload: { actId: firstActivityId } });
            }
          }
        }
        else {
          yield* getActivityDetail({ payload: { actId: payload.actId } });
        }
      }

      //here I need flag for for tour app. i.e. is user already visited this site
      // yield put({ type : HIDE_SHOW_DEFAULT_TOUR, payload : isNewUser || true })

    } else if (status == ErrorCode.RedirectToLogout) {
      yield* logout();
    } else if (APP_ERROR_CODES.indexOf(status) > -1) {
      yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: { status: status, isErrorScreen: true }
      });
    } else {
      yield put({ type: ActionConstants.WORKKARD_DETAIL_MASTER_DATA_ERROR, payload: { errorMessage: WorkkardErrorConstant.WORKKARD_DETAIL_MASTER_DATA_ERROR[status] } });
    }
  } catch (error) {
    yield put({ type: ActionConstants.WORKKARD_DETAIL_MASTER_DATA_ERROR, payload: { errorMessage: error } });
  } finally {
    if (!silent) yield put({ type: HIDE_LOADER });
  }
}


export function* setPanelVisibility({ payload }) {
  try {
    yield put({ type: ActionConstants.PANEL_VISIBILITY_DATA_SUCCESS, payload: payload });
    if (payload.isNoteVisible == false && payload.isNoteCreationVisible == false) {
      yield put({ type: ActionConstants.RESET_NOTE_CREATION_STATE });
    }
  }
  catch (error) {
    yield put({ type: ActionConstants.PANEL_VISIBILITY_DATA_ERROR, payload: payload });
  }
}

export function* getActivityOpenDiaries(action) {
  try {
    yield put({ type: SHOW_LOADER });
    const activityOpenDiaries = yield call(Api.getCloseActivityOpenDiaries, action.payload);
    if (activityOpenDiaries.status != 200) {
      yield put({ type: HIDE_LOADER });
      if (activityOpenDiaries.status == ErrorCode.RedirectToLogout) {
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: activityOpenDiaries.status, isErrorScreen: false }
        });
      }
    } else {
      yield put({ type: ActionConstants.CLOSE_ACTIVITY_RESET_STATE });
      yield put({ type: ActionConstants.FETCH_OPEN_ACTIVITY_DIARIES_REQUEST_SUCCESS, payload: activityOpenDiaries });
    }

  } catch (error) {
    console.log(error);
  }
  finally {
    yield put({ type: HIDE_LOADER });
  }
}

export function* getActivityNotification(action) {
  try {
    yield put({ type: SHOW_LOADER });
    const activityNotifications = yield call(Api.getCloseActivityNotification, action.payload);
    if (activityNotifications.status != 200) {
      yield put({ type: HIDE_LOADER });
      if (activityNotifications.status == ErrorCode.RedirectToLogout) {
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: activityNotifications.status, isErrorScreen: false }
        });
      }
    } else {
      yield put({
        type: ActionConstants.FETCH_ACTIVITY_NOTIFICATION_REQUEST_SUCCESS,
        payload: activityNotifications
      });
    }

  } catch (error) {
    console.log(error);
    //yield put({ type: ActionConstants.FETCH_ACTIVITY_NOTIFICATION_REQUEST_ERROR, error });
  }
  finally {
    yield put({ type: HIDE_LOADER });
  }
}

export function* postActivityMenuActions({ payload }) {
  try {
    yield put({ type: SHOW_LOADER });
   const response = yield call(PUBLIC_API_ACTIVITY_ACTION.actionsForActivities, payload);

    if (response.status != 200) {
      yield put({ type: HIDE_LOADER })
      if (response.status == ErrorCode.RedirectToLogout) {
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: response.status, isErrorScreen: false }
        });
      }
    } else {
      yield* updateActivityListingData({ cId: payload.cId });
      yield* getActivityDetail({ payload: { actId: payload.ActivityId } });

      const getWorkkardDetailData = (state) => state.workkardDetail.workkardDetail;
      const getItems = (state) => state.workkardDetail.middlePanel;
      const middlePanel = yield select(getItems);

      if (middlePanel.notes.type == StringConstants.activity) {
        const param = {
          type: StringConstants.activity,
          actId: payload.ActivityId,
          cId: 0,
          skip: 0,
          take: middlePanel.notes.skip + middlePanel.notes.take || 10,
          sortBy: "0",
          reviewFilter:"0"
        }
        yield* updatePanelDataPermissionSet({ payload: param, permission: { isUpdateNotes: true } })
      }
      if (middlePanel.logs.type == StringConstants.activity) {
        const logsPayload = {
          type: StringConstants.activity,
          cId: 0,
          actId: payload.ActivityId,
          skip: 0,
          take: middlePanel.logs.skip + middlePanel.logs.take || 10
        }
        yield* updatePanelDataPermissionSet({ payload: logsPayload, permission: { isUpdateLogs: true } })
      }

      if (middlePanel.activeTab == 4) {
        const partyPayload = {
          actId: payload.ActivityId || 0,
          cId: payload.cId,
          filterOption: middlePanel.parties.filter.filterOption,
          skip: 0,
          take: 15,
          sortBy: 1,
          sort: "OPEN",
          type: middlePanel.parties.type
      }
        yield* updatePanelDataPermissionSet({ payload: partyPayload , permission:{isUpdateParties:true}});
    }

      const workkardDetailData = yield select(getWorkkardDetailData);
      if (workkardDetailData.WorkkardStatus.toLowerCase() == 'close') {
        yield* getWorkkardDetailMasterData({ payload: { cId: payload.cId, doNotUpdateActivityListing: true } });
      }
      yield put({ type: HIDE_LOADER });
    }
  }
  catch (error) {
    yield put({ type: HIDE_LOADER });
    yield put({
      type: SHOW_TOAST_WITH_PROPS,
      payload: {
        message: error?.errors?.[0]?.message || error?.message || "Unable to perform the activity action.",
        iconType: "error",
        delayTime: 5000,
        autoClose: true
      }
    });
  }
  finally {
    yield put({ type: HIDE_DIALOGUE_BOX });
  }
}

export function* closeActivityFromWeb({ payload }) {
  try {
    yield put({ type: SHOW_LOADER });
    const closeActivityFromWebRes = yield call(Api.postActivityMenuActionsRequest, payload.close_activity_data);
   if (closeActivityFromWebRes.status == 200) {
    payload.callback(closeActivityFromWebRes.status);   
    if (payload.diaries_data.length) {
      yield call(Api.bulkCompleteOpenDiaries, ActionConstants.BULK_COMPLETE_OPEN_DIERIES_REQUEST, payload.diaries_data);
    }
    if (payload.notification_data.activityUpdateIds !== '') {
      yield call(Api.changeactivityupdatestatus, ActionConstants.CHANGE_ACTIVITY_UPDATE_STATUS_REQUEST, payload.notification_data);
    }
    const getItems = (state) => state.workkardDetail;
    const items = yield select(getItems);
    const param = {
      type: items.middlePanel.notes.type,
      actId: items.middlePanel.notes.type === StringConstants.activity ? payload.close_activity_data.ActivityId : 0,
      cId: items.middlePanel.notes.type === StringConstants.workkard ? items.workkardDetail.Id : 0,
      skip: 0,
      take: items.middlePanel.notes.take,
      sortBy: "0",
      reviewFilter: "0"
    }
    yield* updatePanelDataPermissionSet({ payload: param, permission: { isUpdateNotes: true } })
    yield* getWorkkardDetailMasterData({ payload: { cId: items.workkardDetail.Id, doNotUpdateActivityListing: true } });
    yield* updateActivityListingData({ cId: items.workkardDetail.Id });
    yield* getActivityDetail({ payload: { actId: payload.close_activity_data.ActivityId } });
  }
  else if (closeActivityFromWebRes.status != 200) {
    if (closeActivityFromWebRes.status == ErrorCode.UnAuthorize) {
      yield put({
        type: LOG_APPLICATON_ERROR,
        payload: { status: closeActivityFromWebRes.status, isErrorScreen: true }
      });
    }
    else if (closeActivityFromWebRes.status == ErrorCode.RedirectToLogout) {
      yield* logout();
    }
    else if(closeActivityFromWebRes.status == ErrorCode.ActionDenied){
      const errorMessage = closeActivityFromWebRes.error
      yield put({ type: ActionConstants.CLOSE_ACTIVITY_ACTION_DENIED_ERROR_MESSAGE, payload: errorMessage }); 
      payload.callback(closeActivityFromWebRes.status);
    }
     else {
      yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: { status: closeActivityFromWebRes.status, isErrorScreen: false }
      });
      const errorMessage = CLOSE_ACTIVITY_ERROR_VALIDATION_MESSAGE.closeActivityErrorText
      yield put({ type: ActionConstants.CLOSE_ACTIVITY_VALIDATION_ERROR_MESSAGE, payload: errorMessage });
    }
  }
  } catch (error) {
    //yield put({ type: ActionConstants.CLOSE_ACTIVITY_FROM_VIEWS_REQUEST_ERROR, error });
    console.log(error);
  }
  finally {
    yield put({ type: HIDE_LOADER });
    //yield put({ type: HIDE_DIALOGUE_BOX });
  }
}

export function* getCloseWorkkardOpenActivities(action) {
  try {
    yield put({ type: SHOW_LOADER });
    const OpenActivities = yield call(Api.getOpenActivities, action.payload);
    if (OpenActivities.status != 200) {
      if (OpenActivities.status == ErrorCode.RedirectToLogout) {
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: OpenActivities.status, isErrorScreen: false }
        });
      }
    } else {
      let actresetpayload = {
        count: 0,
        outActCount: 0,
        data: {}
      }
      yield put({ type: ActionConstants.CLOSE_WORKKARD_RESET_TAB_STATE, payload: actresetpayload });
      yield put({
        type: ActionConstants.FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST_SUCCESS,
        payload: OpenActivities
      });
    }

  } catch (error) {
    console.log(error);
    //yield put({ type: ActionConstants.FETCH_OPEN_ACTIVITY_DIARIES_REQUEST_ERROR, error });
  }
  finally {
    yield put({ type: HIDE_LOADER });
  }
}

export function* getCloseWorkkardOpenDiaries(action) {
  try {
    yield put({ type: SHOW_LOADER });
    const activityOpenDiaries = yield call(Api.getUserAllOpenDiaries, action.payload);
    if (activityOpenDiaries.status != 200) {
      if (activityOpenDiaries.status == ErrorCode.RedirectToLogout) {
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: activityOpenDiaries.status, isErrorScreen: false }
        });
      }
    } else {
      yield put({
        type: ActionConstants.FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST_SUCCESS,
        payload: activityOpenDiaries
      });
    }

  } catch (error) {
    console.log(error);
    //yield put({ type: ActionConstants.FETCH_OPEN_ACTIVITY_DIARIES_REQUEST_ERROR, error });
  }
  finally {
    yield put({ type: HIDE_LOADER });
  }
}

export function* getCloseWorkkardOpenNotifications(action) {
  try {
    yield put({ type: SHOW_LOADER });
    const activityNotifications = yield call(getNotificationData, {
      wkId: action.payload.wkkdID,
      status: notificationStatus.unRead,
      skip: action.payload.skip,
      take: action.payload.take,
      sortOrder: 'd'
    });
    if (activityNotifications.status != 200) {
      if (activityNotifications.status == ErrorCode.RedirectToLogout) {
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: activityNotifications.status, isErrorScreen: false }
        });
      }
    } else {
      yield put({
        type: ActionConstants.FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST_SUCCESS,
        payload: activityNotifications
      });
    }

  } catch (error) {
    console.log(error);
    //yield put({ type: ActionConstants.FETCH_ACTIVITY_NOTIFICATION_REQUEST_ERROR, error });
  }
  finally {
    yield put({ type: HIDE_LOADER });
  }
}

export function* closeWorkkardPostRequest({ payload }) {
  try {
    yield put({ type: SHOW_LOADER });
    let errorMessage = "";
    const response = yield call(Api.closeWorkkardPermissionRequest, ActionConstants.GET_CLOSE_WORKKARD_PERMISSION);
    if (response.status != 200) {
      if (response.status == ErrorCode.RedirectToLogout) {
        yield* logout();
      } else if(response.status == ErrorCode.ActionDenied) {
        yield put({ type: ActionConstants.CLOSE_WORKKARD_VALIDATION_ERROR_MESSAGE, payload: response.error });
        payload.callback(response.status);
      }else{
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: response.status, isErrorScreen: false }
        });
        errorMessage = CLOSE_WORKKARD_ERROR_VALIDATION_MESSAGE.ErrorMsg;
        yield put({ type: ActionConstants.CLOSE_WORKKARD_VALIDATION_ERROR_MESSAGE, payload: errorMessage });
      }
    } else {
      payload.callback(response.status);
      if (payload.activities_data.activityIds && payload.activities_data.activityIds.length > 0) {
        const closeactres = yield call(Api.closeWorkkardCloseActivities, ActionConstants.BULK_COMPLETE_OPEN_ACTIVITIES_REQUEST, payload.activities_data);
        if (closeactres.status == 200) {
          yield* getWorkkardDetailMasterData({ payload: { cId: payload.close_workkard_data.wkkdID, doNotUpdateActivityListing: true } });
          yield* updateActivityListingData({ cId: payload.close_workkard_data.wkkdID });
          if (payload.close_workkard_data.actId > 0) {
            yield* getActivityDetail({ payload: { actId: payload.close_workkard_data.actId } });
          }
        }
      }
      if (payload.diaries_data.validDiaryIds && payload.diaries_data.validDiaryIds.length > 0) {
        const { status } = yield call(Api.closeWorkkardCompleteDiaries, ActionConstants.CLOSE_WORKKARD_BULK_COMPLETE_OPEN_DIERIES_REQUEST, payload.diaries_data);
        const getItems = (state) => state.workkardDetail;
        const items = yield select(getItems);
        if (status == 200 && items.middlePanel.activeTab == 2) {
          const param = {
            cId: payload.close_workkard_data.wkkdID,
            type: items.middlePanel.diaries.type,
            actId: payload.close_workkard_data.actId || 0,
            skip: items.middlePanel.diaries.skip,
            take: items.middlePanel.diaries.take,
            sortBy: "SortByDueDate",
            filterOption: JSON.stringify(Object.assign([], items.middlePanel.diaries.filter.filterOption, ["activity", "workkard"])),
            sort: items.middlePanel.diaries.filter.sort || "ALL",
            rows: 10,
            todoOwners: items.middlePanel.diaries.filter.todoOwners
          }
          let shouldUpdateDiaries = true
          if (items.middlePanel.diaries.type == StringConstants.activity && payload.close_workkard_data.actId < 1) {
            shouldUpdateDiaries = false
          }
          yield* updatePanelDataPermissionSet({ payload: param, permission: { isUpdateDiaries: shouldUpdateDiaries } })
        }
      }
      if (payload.notification_data.activityUpdateIds && payload.notification_data.activityUpdateIds.length > 0) {
        yield call(Api.changeactivityupdatestatus, ActionConstants.CHANGE_ACTIVITY_UPDATE_STATUS_REQUEST, payload.notification_data);
      }

      if (payload.close_workkard_data.intActCount == 0) {
        const closeWkResponse = yield call(Api.closeWorkkardPostRequest, ActionConstants.CLOSE_WORKKARD_REQUEST, payload.close_workkard_data);
        if (closeWkResponse.status != 200) {
          errorMessage = CLOSE_WORKKARD_ERROR_VALIDATION_MESSAGE.FailureMessage
          yield put({ type: ActionConstants.CLOSE_WORKKARD_VALIDATION_ERROR_MESSAGE, payload: errorMessage });
        } else {
          yield* getWorkkardDetailMasterData({ payload: { cId: payload.close_workkard_data.wkkdID, doNotUpdateActivityListing: true } });
        }
      }
      else {
        yield put({ type: HIDE_DIALOGUE_BOX });
      }
      const isIE = false || !!document.documentMode;
      dispatchCustomEvent(isIE, 'evtcloseworkkardsuccess');
    }
  } catch (error) {
    let errorMessage = CLOSE_WORKKARD_ERROR_VALIDATION_MESSAGE.FailureMessage
    yield put({ type: ActionConstants.CLOSE_WORKKARD_VALIDATION_ERROR_MESSAGE, payload: errorMessage });
  }
  finally {
    yield put({ type: HIDE_LOADER });
  }
}

export function* getActivityReassignRequest() {
  try {
    const sessionContext = yield select(state => state.sessionContextOidc);
    const activityDetail = yield select(state => state.workkardDetail.activityDetail);
    const currentOrgId = Number(getOrgId());

    // Fetch team members and B2B relationships in parallel
    const [usersResponse, relationshipsResponse] = yield all([
      call(SpockApi.getWorkkardOwnerListV2),
      call(fetchRelationships, { status: 'ACCEPTED' }),
    ]);    

    // Team members
    const currentAssigneeId = activityDetail?.activityAssigneeId;
    const usersList = usersResponse?.users || usersResponse?.data?.users || [];
    const TeamMembers = usersList
      .filter(user => user.id !== currentAssigneeId)
      .map(user => ({
        UserId: user.id,
        FirstName: user.first_name || user.user_name || '',
        LastName: user.last_name || '',
        Title: user.user_role || '',
        Email: user.email || '',
        ProfileImage: user.profile_image || '',
      }));

    // B2B list (accepted relationships with the other org resolved)
    const currentOwnerOrgId = activityDetail?.ownerOrgId;
    const relationshipItems = Array.isArray(relationshipsResponse?.business_orgs)
      ? relationshipsResponse.business_orgs
      : [];
    const B2BList = relationshipItems.filter(item =>  item.owner == currentOwnerOrgId)
      .map(item => {
        const otherOrg = item.assignee === currentOrgId
          ? (item.source_org || {})
          : (item.destination_org || {});
        return {
          OrganizationId: otherOrg.id,
          OrganizationName: otherOrg.name || '',
          OrganizationImage: otherOrg.profile_image || '',
        };
      })    
    // Active contracts have to ask this for response 
    let orginList = [];
    try {
      const contractsResponse = yield call(fetchActiveContracts, currentOrgId);
    } catch (e) {
      console.warn('fetchActiveContracts failed', e);
      orginList = [];
    }

    // Permissions from UserView
    const UserView = sessionContext?.userView || {};
    const CanReassignActivityOutside = Boolean(UserView?.permissions?.can_reassign_activity);
    const CanAssignB2B = Boolean(UserView?.permissions?.can_assign_b2b);

    // Timezone & due date
    const tzData = sessionContext?.tzData || [];
    const PrettyDueDate = activityDetail?.dueDateString
    const DueDateTz = activityDetail?.dueDateTz ?? activityDetail?.DueDateTz

    yield put({
      type: GET_REASSIGN_ACTIVITY_REQUEST_SUCCESS,
      payload: {
        reassignActivityModel: {
          TeamMembers,
          B2BList,
          // orginList,
          PrettyDueDate,
          DueDateTz,
          ActivityOwnerOrgId: currentOwnerOrgId,
          CanReassignActivityOutside,
          CanAssignB2B,
        },
        tzData,
      },
    });
  } catch (error) {
    console.log(error, "error in getActivityReassignRequest");
    const errorMessage = CHANGE_ACTIVITY_ASSIGNEE_ERROR_VALIDATION_MESSAGE[400];
    yield put({ type: ActionConstants.SET_VALIDATION_ERROR_MESSAGE, payload: errorMessage });
  }
}

export function* setUserTourStatus() {
  try {
    const response = yield call(Api.setUserTourStatus, ActionConstants.SET_USER_TOUR_STATUS)
  }
  catch (error) {

  }
  finally {

  }

}

export function* getUserTourStatus() {
  try {
    const { status, isNewUser } = yield call(Api.getUserTourStatus, ActionConstants.GET_USER_TOUR_STATUS);
    if (status == 200) {
      yield put({ type: ActionConstants.HIDE_SHOW_DEFAULT_TOUR, payload: isNewUser || false })
    }
  }
  catch (error) {
    console.log('error: ', error);

  }
  finally {

  }

}

export function* logout() {
  try {
    yield put(wsDisconnect());
    yield (window.location.href = PATHS.LOGOUT);
  }
  catch (error) {

  }
  finally {

  }
}

export function* resolutionBasedClass({ payload }) {
  try {
    yield put({ type: SHOW_LOADER });
    yield put({
      type: ActionConstants.RESOLUTION_BASED_CLASS_SUCCESS,
      payload
    })
  }
  catch (error) {

  }
  finally {
    yield put({ type: HIDE_LOADER })
  }
}

const UPDATE_PROJECTION_SOCKET_TIMEOUT_MS = 5000;
const WORKKARD_UPDATE_EVENTS = new Set([
  'workkard.updated',
  'workkard.reopened',
  'workkard.closed',
  'workkard.open',
  'workkard.sponsor.changed',
]);

function* takeMatchingWorkkardUpdate(workkardId) {
  while (true) {
    const { payload } = yield take(WS_MESSAGE);
    if (!WORKKARD_UPDATE_EVENTS.has(payload?.event)) continue;
    if (String(payload?.entity?.workkardId) !== String(workkardId)) continue;
    return true;
  }
}

function* awaitWorkkardUpdateProjection(workkardId) {
  yield race({
    updated: call(takeMatchingWorkkardUpdate, workkardId),
    timeout: call(delay, UPDATE_PROJECTION_SOCKET_TIMEOUT_MS),
  });
}

export function* updateWorkkardField({ payload }) {
  try {
    yield put({ type: ActionConstants.SHOW_DETAIL_PAGE_LOADER });
    const { callback } = payload;
    delete payload.callback;

    const getWorkkardDetailData = (state) => state.workkardDetail;
    const workkardDetailData = yield select(getWorkkardDetailData);
    const workkard = workkardDetailData.workkardDetail;
    const workkardId = workkard.Id;

    const fieldsResponse = yield call(Api.fetchWorkkardTemplateFields, workkard.TemplateShortName);
    const fieldsMeta = fieldsResponse?.fields ?? fieldsResponse?.data ?? fieldsResponse?.Data ?? [];

    const apiPayload = buildInlineFieldPatch(payload, Array.isArray(fieldsMeta) ? fieldsMeta : []);
    const response = yield call(Api.updateWorkkardTemplateFields, workkardId, apiPayload);
    const isError = !response || response.status === 400 || response.error;

    if (!isError) {
      const toggleCombinedView = (state) => state.workkardDetail.panelVisibility;
      const isCombinedView = yield select(toggleCombinedView);
      if (workkardDetailData.middlePanel.activeTab == 3 && (workkardDetailData.middlePanel.logs.type == "workkard")) {
        const paramLogs = {
          type: workkardDetailData.middlePanel.logs.type,
          cId: workkardDetailData.workkardDetail.Id,
          actId: workkardDetailData.activityDetail.activityId,
          skip: 0,
          take: 10,
          sortBy: "0"
        };
        yield* updatePanelDataPermissionSet({ payload: paramLogs, permission: { isUpdateLogs: true } })
      }
      if (isCombinedView.toggleView == RightPanelConstant.CombinedViewText) {
        const combinedViewPayload = {
          id: workkardDetailData.workkardDetail.Id,
          start: workkardDetailData.combinedView.start,
          end: workkardDetailData.combinedView.end
        }
        yield put({ type: ActionConstants.RESET_ALL_COMBINED_VIEW_DATA })
        yield* updatePanelDataPermissionSet({ payload: combinedViewPayload, permission: { isUpdateCombinedView: true } })
      }
      yield call(awaitWorkkardUpdateProjection, workkardId);
      const { status, workkard: refreshedWorkkard, menuList } = yield call(Api.getWorkkardDetailMasterData, { cId: workkardId });
      if (status == 200 && refreshedWorkkard) {
        refreshedWorkkard.ActionMenu = menuList
        yield put({ type: ActionConstants.WORKKARD_DETAIL_MASTER_DATA_SUCCESS, payload: refreshedWorkkard });
      }
      callback();
    } else if (response?.status == ErrorCode.RedirectToLogout) {
      yield* logout();
    } else {
      yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: { status: response?.status, isErrorScreen: false }
      });
    }
  }
  catch (error) {
    console.log('error: ', error);
  }
  finally {
    yield put({ type: ActionConstants.HIDE_DETAIL_PAGE_LOADER })
  }
}

export function* fetchWorkkardCarrier() {
  try {
    const { status, Data } = yield call(Api.fetchWorkkardCarrier);
    if (status == 200) {
      yield put({ type: ActionConstants.FETCH_WORKKARD_CARRIER_SUCCESS, payload: Data })
    }
  }
  catch (error) {
    console.log('error: ', error);

  }
  finally {
  }
}

  export function* getTimezoneByZip({payload}){
    try {
      const {status, timezone} = yield call(Api.getTimezoneByZip,ActionConstants.GET_TIMEZONE_BY_ZIP,payload);
      if(status == 200){
        yield put({
          type: ActionConstants.GET_TIMEZONE_BY_ZIP_SUCCESS,
          payload:{timeZoneValue:timezone}
        })
      }
    }
    catch(error){
      console.log(error);
    }
    finally {
      yield put ({ type : HIDE_LOADER })
    }
  }

  export function* getsavednotefilters({ payload }) {
    try {
      let view = noteFilterConstants.Activity
      if(payload.combined){
        view = noteFilterConstants.CombineView;
      }
      payload.view = view
      const getWorkkardDetailData=(state)=>state.workkardDetail;
      const workkardDetailData=yield select(getWorkkardDetailData);
      
      let activityNoteFilters = yield call(PUBLIC_API_NOTE_ACTIONS.GetActivityNoteFilters, payload)
      if (activityNoteFilters?.default_filter?.length){
        let defaultnoteFilters = {};
        let noteFilters = DigestNoteFilters(activityNoteFilters?.note_filters, activityNoteFilters?.default_filter && activityNoteFilters?.default_filter.find((x) => x.view == view));
        if(view == noteFilterConstants.Activity){
          defaultnoteFilters = DigestNoteFilters([], activityNoteFilters?.default_filter && activityNoteFilters?.default_filter.find((x) => x.view == noteFilterConstants.CombineView));
          yield put({
            type: ActionConstants.ACTIVITY_NOTE_TEMPLATES_SUCCESS,
              payload: { excludedFilters: Object.assign({}, ...workkardDetailData.middlePanel.excludedFilters, ...noteFilters)}
          });
          yield put ({
            type: ActionConstants.FETCH_COMBINED_VIEW_DATA_SUCCESS,
            payload: { cvExcludedFilters: Object.assign({}, ...workkardDetailData.combinedView.cvExcludedFilters, ...defaultnoteFilters)}
          })
        } else {
          defaultnoteFilters = DigestNoteFilters([], activityNoteFilters?.default_filter && activityNoteFilters?.default_filter.find((x) => x.view == noteFilterConstants.Activity));
          yield put ({
            type: ActionConstants.FETCH_COMBINED_VIEW_DATA_SUCCESS,
            payload: { cvExcludedFilters: Object.assign({}, ...workkardDetailData.combinedView.cvExcludedFilters, ...noteFilters) }
          })
          yield put({
            type: ActionConstants.ACTIVITY_NOTE_TEMPLATES_SUCCESS,
            payload: {excludedFilters: Object.assign({}, ...workkardDetailData.middlePanel.excludedFilters, ...defaultnoteFilters)}
          });
        }
      }      
      if (payload.callback) {
        payload.callback();
      }
    } catch (error) {
      console.log(error);
      getAxiosError(error);
    } finally {
      
    }
  }

export function* postPinnedWorkkardFields({payload}) {
    try {
      const response = yield call(Api.updateUserPinnedFields, ActionConstants.UPDATE_USER_PINNED_FIELDS, payload);
      if (response) {
        const pinned_fields = (payload.pinned_field || "")
          .split(",")
          .map(cf_key => cf_key.trim())
          .filter(Boolean)
          .map((cf_key, index) => ({ seq_no: index + 1, cf_key }));
        yield put({ type: ActionConstants.WORKKARD_DETAIL_MASTER_DATA_SUCCESS, payload: { pinned_fields } });
      }
    } catch (error) {
    } finally {
      
    }
  }
  
  export function* resetPinnedWorkkardFields({payload}) {
    try {
      const response = yield call(Api.updateUserPinnedFields, ActionConstants.UPDATE_USER_PINNED_FIELDS, { pinned_field: "", template_id: payload.templateId });
      if (response) {
        yield* getWorkkardDetailMasterData({ payload: { cId: payload.wkId, doNotUpdateActivityListing: true, resetPinnedFields: true } });
      }
    } catch (error) {
    } finally {
      
    }
  }

  export function* fetchUserDetail(payload) {
    try {
      yield* hydrateUsers(payload?.uniqueUserIds);
    } catch (error) {
    } finally {
    }
  }

export default [
    takeLatest(ActionConstants.FETCH_WORKKARD_DETAIL_MASTER_DATA, getWorkkardDetailMasterData),
    takeLatest(ActionConstants.UPDATE_WORKKARD_FIELD, updateWorkkardField),
    takeLatest(ActionConstants.FETCH_WORKKARD_CARRIER, fetchWorkkardCarrier),
    takeLatest(ActionConstants.PANEL_VISIBILITY_DATA_REQUEST, setPanelVisibility),
    takeLatest(ActionConstants.FETCH_OPEN_ACTIVITY_DIARIES_REQUEST, getActivityOpenDiaries),
    takeLatest(ActionConstants.FETCH_ACTIVITY_NOTIFICATION_REQUEST, getActivityNotification),
    takeLatest(ActionConstants.POST_ACTIVITY_MENU_ACTION_REQUEST, postActivityMenuActions),
    takeLatest(ActionConstants.CLOSE_ACTIVITY_REQUEST, closeActivityFromWeb),
    takeLatest(ActionConstants.FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST, getCloseWorkkardOpenActivities),
    takeLatest(ActionConstants.FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST, getCloseWorkkardOpenDiaries),
    takeLatest(ActionConstants.FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST, getCloseWorkkardOpenNotifications),
    takeLatest(ActionConstants.CLOSE_WORKKARD_REQUEST, closeWorkkardPostRequest),
    takeLatest(ActionConstants.SET_USER_TOUR_STATUS, setUserTourStatus),
    takeLatest(ActionConstants.GET_USER_TOUR_STATUS, getUserTourStatus),
    takeLatest(ActionConstants.RESOLUTION_BASED_CLASS_REQUEST, resolutionBasedClass),
    takeLatest(ActionConstants.GET_TIMEZONE_BY_ZIP,getTimezoneByZip),
    takeLatest(GET_REASSIGN_ACTIVITY_REQUEST, getActivityReassignRequest),
    takeLatest(ActionConstants.GET_SAVED_NOTE_FILTER_DATA, getsavednotefilters),
    takeLatest(ActionConstants.UPDATE_USER_PINNED_FIELDS, postPinnedWorkkardFields),
    takeLatest(ActionConstants.RESET_USER_CUSTOM_FIELD_DATA, resetPinnedWorkkardFields),
    takeLatest(ActionConstants.FETCH_USERS_DETAIL, fetchUserDetail)
  ];
  
